import autosizeLib from "autosize";
import * as React from "react";
import { useEffect, useRef } from "react";

import { cn } from "@/utils/shadcn-ui";

function BaseTextarea({
  className,
  autosize,
  ...props
}: React.ComponentProps<"textarea"> & { autosize?: boolean }) {
  const innerRef = useRef<HTMLTextAreaElement>(null);
  const ref = (props as any).ref ?? innerRef;

  useEffect(() => {
    const element = ref.current;
    if (autosize && element) {
      autosizeLib(element);
      return () => autosizeLib.destroy(element);
    }
  }, [autosize, ref]);

  useEffect(() => {
    if (autosize && ref.current) {
      autosizeLib.update(ref.current);
    }
  }, [props.value, autosize, ref]);

  return (
    <textarea
      data-slot="textarea"
      ref={ref}
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive focus-visible:aria-invalid:ring-ring/50 focus-visible:aria-invalid:border-ring dark:bg-input/30 flex field-sizing-content w-full rounded-md border bg-white px-3 py-1.5 text-sm transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 resize-none",
        className,
      )}
      {...props}
    />
  );
}

export { BaseTextarea };
